import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  forRentWigsDetails: {},
  isLoading: false,
  showDialog: false,
};

//STORE SLICE
export const forRentWigsDetailsSlice = createSlice({
  name: "forRentWigsDetailsSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showForRentWigsDetailsDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        forRentWigsDetails: action.payload,
      };
    },
    closeForRentWigsDetailsDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showForRentWigsDetailsDialog,
  closeForRentWigsDetailsDialog,
  showLoading,
  hideLoading
} = forRentWigsDetailsSlice.actions;

export default forRentWigsDetailsSlice.reducer;
